var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor table-update-record" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("section", [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Table ID")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-selection-row" },
          [
            _c("CustomPicker", {
              attrs: {
                items: _vm.tables,
                idKey: "_id",
                labelKey: "name",
                title: "Select Table",
              },
              model: {
                value: _vm.clone.tableId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "tableId", $$v)
                },
                expression: "clone.tableId",
              },
            }),
            _vm._v(" "),
            _vm.clone.tableId
              ? _c(
                  "SupsisButton",
                  {
                    staticClass: "go-to-table-btn",
                    attrs: { ghost: "" },
                    on: { click: _vm.goToTable },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("visibility"),
                    ]),
                    _vm._v(
                      "\n                    Tabloya Git\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Record ID")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-editor-wrapper" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Record ID",
                "show-attributes": true,
                "show-emoji": true,
                "max-character-count": 1024,
              },
              model: {
                value: _vm.clone.recordId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "recordId", $$v)
                },
                expression: "clone.recordId",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.getSelectedTable()
        ? _c(
            "section",
            [
              _c("div", { staticClass: "title" }, [_vm._v("Update Fields")]),
              _vm._v(" "),
              _vm._l(_vm.clone.fields, function (fieldItem, index) {
                return _c(
                  "div",
                  { key: fieldItem.id, staticClass: "field-row" },
                  [
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm
                          .getSelectedTable()
                          .fields.filter(function (f) {
                            return !f.fieldType.startsWith("record_")
                          })
                          .filter(function (f) {
                            return f.fieldType !== "lookup"
                          })
                          .filter(function (f) {
                            return f.fieldType !== "formula"
                          }),
                        idKey: "_id",
                        labelKey: "name",
                        title: "Select Field",
                      },
                      model: {
                        value: fieldItem.fieldId,
                        callback: function ($$v) {
                          _vm.$set(fieldItem, "fieldId", $$v)
                        },
                        expression: "fieldItem.fieldId",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-value-col" }, [
                      _vm.isMultiAssetField(fieldItem.fieldId)
                        ? _c("div", { staticClass: "multi-asset-hint" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info_outline"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("auto.createRecordMultiAssetTooltip")
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-editor-wrapper" },
                        [
                          _c("TiptapEditor", {
                            attrs: {
                              placeholder: "Value",
                              "show-attributes": true,
                              "show-emoji": true,
                              "max-character-count": 1024,
                            },
                            model: {
                              value: fieldItem.value,
                              callback: function ($$v) {
                                _vm.$set(fieldItem, "value", $$v)
                              },
                              expression: "fieldItem.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.removeField(index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.delete")))]
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.addField } }, [
                _vm._v("+ " + _vm._s(_vm.$t("calendar.addField"))),
              ]),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }